import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { restBaseUri } from '../../config';
import { PageTitle } from '../../components/layouts/page/PageTitle';

export const AuthorDetailPage = () => {
  const { id }: any = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    axios
      .get(`${restBaseUri}/authors/${id}`)
      .then(({ data }) => {
        setAuthor(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Loading</div>;
  }

  return (
    <Layout.Content>
      <PageTitle onBack={() => navigate(-1)} title={"Authors"} />

      Author found
    </Layout.Content>
  );
};
